<template>
<nav class="navbar navbar-dark navbar-expand-lg  bg-dark ">
  <div class="container-fluid">
    <a class="navbar-brand" :to="{name:'pricing'}">{{$t('navbar')}}</a>
    <button class="navbar-toggler" @click="navbarShow=!navbarShow" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" :class="{'show':navbarShow}" >
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
      <!--  <li class="nav-item">
          <router-link class="nav-link active" aria-current="page" :to="{name:'home'}">{{$t('home')}}</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" :to="{name:'pricing'}">{{$t('pricing')}}</router-link >
        </li>
        <li class="nav-item">
          <a class="nav-link disabled">Disabled</a>
        </li>-->
      </ul>
      <ul class="nav navbar-nav navbar-right">
     <!-- <li><router-link class="nav-link"  v-if="!getUser" :to="{name:'register'}"><span class="glyphicon glyphicon-user"></span> Sign Up</router-link></li>-->
      <li><router-link class="nav-link" v-if="!getUser" :to="{name:'login'}"><span class="glyphicon glyphicon-log-in"></span> Login</router-link></li>
      <li class="nav-item dropdown" v-if="UserRoleControl">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            {{$t('adminmenu')}}
          </a>
          <ul class="dropdown-menu">
            <li><router-link class="dropdown-item" :to="{name:'userlist'}">{{$t('userList')}}</router-link></li>
            <li><router-link class="dropdown-item" :to="{name:'roleList'}">{{$t('rolePage')}}</router-link></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
       </ul>
      <div class="nav navbar-nav navbar-right" v-if="getUser"> 
     <button class="btn btn-primary btn-sm capitalize mx-1" @click="$router.push({name:'dashboard'})">{{getUser?.nameSurname}}</button>
     <button class="btn btn-primary btn-sm capitalize mx-1" @click="Logout">{{$t('logout')}}</button>
    </div>
    
    </div>
  </div>
</nav>
</template>
<script>
import { mapGetters } from 'vuex';

export default{
data(){
    return {
        navbarShow:false,
    }
},
computed:{
  ...mapGetters({
    getUser:'user/getUser'
  }),
  UserRoleControl(){
    return this.getUser?.userRole==="Admin"?true:false;
  }
},
methods:{
  Logout(){
    this.$router.push({name:'home'})
    this.$store.commit('user/setUser',null)
  }
}
}
</script>
<style scoped>
.capitalize{
  text-transform: capitalize;
}
@media(max-width:919px){
  .btn{
    margin-top:0.5rem;
  }
}
</style>
